"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _themr = require("../../../themr");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * It's wrapper for themr from `react-css-themr`.
 * It's need to get clean theme api from `*.css.json`.
 *
 * @param {string} componentIdentifier, unique component name
 * @param {Object} [themeCssJson={}], json data obtained from postcss-modules
 * @param {string[]} [themeApiFilter=null], set of css classes
 * @param {Object} [options={}], for `react-css-themr`
 */
var _default = exports["default"] = function _default(componentIdentifier) {
  var themeCssJson = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var themeApiFilter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var cleanCssJson = null;
  if (Array.isArray(themeApiFilter)) {
    cleanCssJson = (0, _pick2["default"])(themeCssJson, themeApiFilter);
  }
  return (0, _themr.themr)(componentIdentifier, cleanCssJson || themeCssJson, options);
};